import { Timestamp } from "./timestamp";

export class RiderEmail {
	uid: string = "";
	email: string = "";
	centralUserUid: string = "";
	legacyOwnershipRequiresReview: boolean = false;
	appUserUids: Array<string> = [];

	constructor() {}

	buildModel(lap: RiderEmail) {
		for (var key in lap) {
			if (lap.hasOwnProperty(key)) {
				switch (key) {
					default:
						if (lap[key] && lap[key].getTime) {
							this[key] = new Timestamp(lap[key].getTime() / 1000, 0);
						} else {
							this[key] = lap[key] != undefined ? lap[key] : null;
						}
						break;
				}
			}
		}
		return this;
	}

	addUserUid(userUid: string) {
		if (this.appUserUids.find((uid) => uid === userUid)) {
			return;
		}
		if (this.appUserUids.length >= 10) {
			throw new Error("An account can manage up to ten riders.");
		}
		this.appUserUids.push(userUid);
	}

	removeUserUid(index: number) {
		this.appUserUids.splice(index, 1);
	}

	toObj() {
		return {
			uid: this.uid,
			email: this.email,
			centralUserUid: this.centralUserUid,
			appUserUids: this.appUserUids,
		};
	}
}
